import AxiosClient from "../../../services/axios.services";

class GoalPerYearServices {
  getGoalPerYear = (params) =>
    AxiosClient.get("/api/app/capacitacion_meta_x_anio/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveGoalPerYear = (data) =>
    AxiosClient.post("/api/app/capacitacion_meta_x_anio/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editGoalPerYear = (id, data) =>
    AxiosClient.put(`/api/app/capacitacion_meta_x_anio/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteGoalPerYear = (id) =>
    AxiosClient.delete(`/api/app/capacitacion_meta_x_anio/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new GoalPerYearServices();
